import { META_PIXEL_ID, LEAD_WEBHOOK_URL } from './config';

declare global { interface Window { fbq?: any; _fbq?: any; } }

export function initPixel() {
  if (typeof window === 'undefined' || window.fbq || !META_PIXEL_ID || META_PIXEL_ID === 'YOUR_PIXEL_ID') return;
  /* eslint-disable */
  (function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return;
    const n: any = (f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    const t = b.createElement(e); t.async = true; t.src = v;
    const s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', META_PIXEL_ID);
}

export function track(event: string, params?: Record<string, any>) {
  try { if (window.fbq) window.fbq('track', event, params || {}); } catch (e) {}
}

// UTMs del anuncio: se guardan en la primera visita y viajan con cada envío a GHL
function utms(): Record<string, string> {
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  const out: Record<string, string> = {};
  try {
    const q = new URLSearchParams(window.location.search || window.location.hash.split('?')[1] || '');
    keys.forEach((k) => { const v = q.get(k); if (v) sessionStorage.setItem(`chale_${k}`, v); });
    keys.forEach((k) => { const v = sessionStorage.getItem(`chale_${k}`); if (v) out[k] = v; });
  } catch {}
  return out;
}

// IMPORTANTE: se envía como form data plano (sin header JSON).
// GHL Inbound Webhook bloquea JSON desde el navegador por CORS (ya pasó en la landing de Studio Web VIP, sept 24).
export async function sendLead(payload: Record<string, any>) {
  if (!LEAD_WEBHOOK_URL) return;
  const body = new URLSearchParams();
  Object.entries({ ...utms(), ...payload }).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    body.append(k, typeof v === 'object' ? JSON.stringify(v) : String(v));
  });
  try {
    // POST application/x-www-form-urlencoded (header explícito; sigue siendo una petición "simple", sin bloqueo CORS)
    await fetch(LEAD_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body,
      keepalive: true,
    });
  } catch {}
}

export function getLead(): Record<string, any> {
  try { return JSON.parse(sessionStorage.getItem('chale_lead') || '{}'); } catch { return {}; }
}
export function saveLead(data: Record<string, any>) {
  try { sessionStorage.setItem('chale_lead', JSON.stringify({ ...getLead(), ...data })); } catch {}
}
export function firstName() {
  return String(getLead().name || '').trim().split(' ')[0];
}
